import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=3415e0c6&scoped=true&"
import script from "./EditPage.vue?vue&type=script&lang=ts&"
export * from "./EditPage.vue?vue&type=script&lang=ts&"
import style0 from "./EditPage.vue?vue&type=style&index=0&id=3415e0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3415e0c6",
  null
  
)

export default component.exports